"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _BaseForm = _interopRequireDefault(require("./BaseForm"));

var _nothing = _interopRequireDefault(require("./nothing"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Quick = function Quick(parent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_parent) {
    (0, _inherits2["default"])(_class, _parent);

    function _class() {
      (0, _classCallCheck2["default"])(this, _class);
      return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_class).apply(this, arguments));
    }

    (0, _createClass2["default"])(_class, [{
      key: "getNativeFormProps",
      value: function getNativeFormProps() {
        var _get$call = (0, _get2["default"])((0, _getPrototypeOf2["default"])(_class.prototype), "getNativeFormProps", this).call(this),
            _get$call$autoField = _get$call.autoField,
            AutoField = _get$call$autoField === void 0 ? this.getAutoField() : _get$call$autoField,
            _get$call$errorsField = _get$call.errorsField,
            ErrorsField = _get$call$errorsField === void 0 ? this.getErrorsField() : _get$call$errorsField,
            _get$call$submitField = _get$call.submitField,
            SubmitField = _get$call$submitField === void 0 ? this.getSubmitField() : _get$call$submitField,
            props = (0, _objectWithoutProperties2["default"])(_get$call, ["autoField", "errorsField", "submitField"]);

        if (!props.children) {
          props.children = this.getChildContextSchema().getSubfields().map(function (key) {
            return _react["default"].createElement(AutoField, {
              key: key,
              name: key
            });
          }).concat([_react["default"].createElement(ErrorsField, {
            key: "$ErrorsField"
          }), _react["default"].createElement(SubmitField, {
            key: "$SubmitField"
          })]);
        }

        return props;
      }
    }, {
      key: "getAutoField",
      value: function getAutoField() {
        return function () {
          return _nothing["default"];
        };
      }
    }, {
      key: "getErrorsField",
      value: function getErrorsField() {
        return function () {
          return _nothing["default"];
        };
      }
    }, {
      key: "getSubmitField",
      value: function getSubmitField() {
        return function () {
          return _nothing["default"];
        };
      }
    }]);
    return _class;
  }(parent), _class.Quick = Quick, _class.displayName = "Quick".concat(parent.displayName), _class.propTypes = _objectSpread({}, parent.propTypes, {
    autoField: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
    errorsField: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
    submitField: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string])
  }), _temp;
};

var _default = Quick(_BaseForm["default"]);

exports["default"] = _default;